<!--点位对象 属性-->
<template>
  <div>
    <gs-modal v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-' + pointDataName : '新建-' + pointDataName" :has-form="true" class="my-test-class"
      @close="close" @confirm="handleConfirm" width="30%">

      <gs-form :model="form" label-width="60px" label-position="left" gap="small">
        <gs-form-item label="名称" prop="target" class="form-item-radio">
          <gs-input v-model="name" />
        </gs-form-item>
        <gs-form-item label="描述" prop="target" class="form-item-radio">
          <gs-input v-model="description" />
        </gs-form-item>
        <gs-form-item label="公式" prop="target" class="form-item-radio">
          <el-input v-model="enableFormula" @input="handleFormulaInput" @blur="handleFormulaBlur" type="textarea"
            :rows="2" />
        </gs-form-item>
        <gs-form-item label="" label-width="0px" prop="target" class="form-item-radio">
          <span style="color: #FF7F00;cursor: pointer;" @click="addressChange">选择触发点位</span>
          <span>{{ triggerObj.fullName }}</span>
        </gs-form-item>

        <div>
          <div class="form-item-objectSeries">
            <gs-table v-if="visible" ref="objTable" :data="tableData" height="200">
              <gs-table-column :show-overflow-tooltip="true" prop="countName" label="参数" width="30" />
              <gs-table-column :show-overflow-tooltip="true" prop="name" label="数据名" data-align="right" width="30" />
              <gs-table-column :show-overflow-tooltip="true" prop="address" label="路径" data-align="right" width="60" />
              <gs-table-column :show-overflow-tooltip="true" prop="type" label="" width="20">
                <template slot-scope="scope">
                  <!--<gs-button @click="add(scope.row)">添加</gs-button>-->
                  <i class="el-icon-circle-plus-outline" @click="add(scope.row)"></i>
                </template>
              </gs-table-column>
            </gs-table>
          </div>
        </div>
      </gs-form>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--  <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button> -->
      </span>
    </gs-modal>
    <gs-modal title="帮助-模拟量" v-model="dialogHelp" class="my-test-class" :before-close="handleCloseHelp">
      <span class="tit">描述：</span><span class="txt">该数据的详细描述</span><br>
      <span class="tit">值：</span><span class="txt">数据的当前值</span><br>
      <span class="tit">单位：</span><span class="txt">数据单位</span><br>
      <span class="tit">计算公式：</span><span class="txt">a为当前点位原始值，公式例如：a*10-5、a/10</span><br>
      <span class="tit">报警状态：</span><span class="txt">设定数据的报警状态</span><br>
      <span class="tit">强制操作：</span><span class="txt">强制操作该数据</span><br>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加"
      @close="beforeCloseAdd" @confirm="handleConfirmAdd" top="100px">
      <div style="height: 400px;overflow: auto;" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'

export default {
  data() {
    return {
      pointDataName: '值计算',
      dialogHelp: false,
      isEdit: false,
      loading: false,
      form: {},
      tableData: [],
      description: '',
      name: '',
      enableFormula: '',
      visibleAdd: false,
      addList: [],
      props: {
        label: "name",
        disabled: "type:folder",
      },
      tableObj: {},
      pointType: "1",
      triggerObj: {},// 触发点位
      sendData: {
        name: "",
        parentId: "",
        id: null,
        type: 'value_calculation',
        description: "",
        fullId: null,
        unit: null,
        secondName: null,
        memo: null,
        mqttId: null,
        keyPrefix: null,
        attribute: {
          realTimeValue: [],
          notRealTimeValue: [],
          formulaMap: {},
          formulaValue: [],
          echoMap: {},
          status: true,
          objectServices: [],
          formula: "",
          condition: 'a==1', // 不填
          conditionRealTimeValue: [],// 不填
          conditionNotRealTimeValue: [],// 不填
          conditionFormulaMap: {},// 不填
          conditionFormulaValue: [],// 不填
          conditionEchoMap: {},// 不填
          conditionObjectServices: [],// 不填
        },
      }
    }
  },

  computed: {
    ...mapState({
      visible: "valueCalculationShow",
      nodeData: "nodeTree",
      objectData: "objectInfo",
    }),
  },

  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      // 回显数据
      this.objectInfo = JSON.parse(JSON.stringify(this.objectData));
      if (JSON.stringify(this.objectInfo) !== "{}" &&
        this.objectInfo.type == "value_calculation") {
        service.getNode(this.objectInfo.id).then(res => {
          this.objectInfo = res
          this.isEdit = true;
          this.name = this.objectInfo.name
          this.description = this.objectInfo.description
          this.enableFormula = this.objectInfo.attribute.formula
          this.triggerObj = this.objectInfo.attribute.conditionObjectServices[0]
          this.sendData.id = this.objectInfo.id
          this.assembleTableData()
        })
      } else {
        // 创建时候的
        this.isEdit = false;
        this.sendData.id = null
        this.clearSendData()
      }
    },
    objectData() {

    }
  },

  methods: {
    ...mapMutations({
      close: 'VALUE_CALCULATION_HIDE',
    }),
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    handleCloseHelp() {
      this.dialogHelp = false
    },

    beforeClose() {
      this.tableData = []
      this.enableFormula = ''
      this.name = ''
      this.description = ''
      this.triggerObj = {}
      this.clearSendData()
      this.close()
    },
    beforeConfirm(e, done) {
      if (!this.name) {
        this.$Message.warning('名称不能为空!')
        return
      }

      if (!this.validateFormula(this.enableFormula)) {
        return
      }
      done()
    },

    handleConfirm() {
      // 提交逻辑
      console.log(this.nodeData, "节点")
      console.log(this.enableFormula, "这个是公式")
      console.log(this.triggerObj, "这个是出发点位")
      console.log(this.tableData, "这个是表格内容")
      this.sendData.name = this.name;
      this.sendData.parentId = this.nodeData.id;
      this.sendData.description = this.description;
      // 对数据进行处理
      this.assemblyData()
      this.conditionData()
      console.log(this.sendData, "最后像后端发送的数据")
      if (!this.isEdit) {
        service.newAddPoint(this.sendData).then(res => {
          this.$message.success("创建成功")
        })
      } else {
        service.renamePoint(this.sendData).then(res => {
          this.$message.success("修改成功")
        })
      }
      this.beforeClose()
    },

    /**
     * 输入中：只提取变量
     */
    handleFormulaInput(val) {
      if (!val) {
        this.tableData = []
        return
      }

      const variableReg = /\b[a-z][a-z0-9]*\b/g
      const vars = val.match(variableReg) || []
      const uniqueVars = Array.from(new Set(vars))

      this.syncTableData(uniqueVars)
    },

    /**
     * 光标移出：校验公式
     */
    handleFormulaBlur() {
      if (!this.enableFormula) return
      this.validateFormula(this.enableFormula)
    },

    /**
     * 公式校验（最终规则）
     */
    validateFormula(formula) {
      // 1. 禁止等号
      if (/=/.test(formula)) {
        this.$Message.warning('公式不允许包含等号 =')
        return false
      }

      // 2. 字符合法性
      const validCharReg = /^[a-zA-Z0-9\s+\-*/().<>]+$/
      if (!validCharReg.test(formula)) {
        /*  this.$Message.warning('公式包含非法字符') */
        return false
      }

      // 3. 必须包含比较符 < 或 >
      /* const compareReg = /[<>]/
      if (!compareReg.test(formula)) {
        this.$Message.warning('公式必须包含 < 或 > 比较符')
        return false
      } */

      return true
    },

    /**
     * 同步 tableData
     */
    syncTableData(vars) {
      const existVars = this.tableData.map(item => item.countName)
      vars.forEach(v => {
        if (!existVars.includes(v)) {
          this.tableData.push({
            countName: v,
            name: '',
            address: '',
            type: '',
            pointData: null     // ★完整点位对象（真实绑定）
          })
        }
      })
      this.tableData = this.tableData.filter(item =>
        vars.includes(item.countName)
      )
    },
    /**
     * 点位绑定（后续）
     */
    add(row) {
      this.pointType = "2"
      this.tableObj = row;
      this.addList = [];
      let _this = this;
      this.visibleAdd = true;
      if (this.nodeData.type == "project" || this.nodeData.type == "server") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 30000);
        setTimeout(() => {
          service.getAllTree().then((res) => {
            _this.addList = res;
          });
        }, 1000);
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree("", this.nodeData.id).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          _this.addList = res;
        });
      } else {
        service.getTree("Point", this.nodeData.id).then((res) => {
          this.addList = res;
        });
      }
    },
    addressChange() {
      this.pointType = "1"
      this.addList = [];
      let _this = this;
      this.visibleAdd = true;
      if (this.nodeData.type == "project" || this.nodeData.type == "server") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 30000);
        setTimeout(() => {
          service.getAllTree().then((res) => {
            _this.addList = res;
          });
        }, 1000);
      } else if (this.nodeData.type == "logicalGroup") {
        service.getTree("", this.nodeData.id).then((res) => {
          res[0].children.forEach((item) => {
            service.getTree("Point", item.id).then((restree) => {
              item.children = restree[0].children;
            });
          });
          _this.addList = res;
        });
      } else {
        service.getTree("Point", this.nodeData.id).then((res) => {
          this.addList = res;
        });
      }
    },
    handleConfirmAdd() {
      const checkedNodes = this.$refs.tree.getCheckedNodes(true)
      if (!checkedNodes.length) {
        this.$Message.warning('请选择一个点位')
        return
      }
      const selectedPoint = checkedNodes[0].data
      if (this.pointType === "1") {
        // 触发点位
        this.triggerObj = selectedPoint
      } else {
        // ★ 变量绑定点位
        if (!this.tableObj) return
        this.tableObj.name = selectedPoint.name
        this.tableObj.address = selectedPoint.fullName
        this.tableObj.pointData = selectedPoint   // ★完整绑定
      }
      this.visibleAdd = false
    },
    checkEvent(node, isSelect, halfSelect) {
      let leafCheckArr = this.$refs.tree.getCheckedKeys();
      if (leafCheckArr.length > 1) {
        leafCheckArr.forEach((item) => {
          if (item != node.id) {
            this.$refs.tree.setChecked(item, false);
          }
        });
      }
    },
    assemblyData() {
      this.sendData.attribute.formula = this.enableFormula
      this.tableData.forEach(item => {
        // 实时数据，非实时数据区分
        if (item.pointData.realTime) {
          this.sendData.attribute.realTimeValue.push(item.pointData.id)
        } else {
          this.sendData.attribute.notRealTimeValue.push(item.pointData.id)
        }
        // 公式对应关系判断
        this.sendData.attribute.formulaMap[item.countName] = item.pointData.id
        // 实时数据+非实时数据
        this.sendData.attribute.formulaValue.push(item.pointData.id)
        // 变量和点位对应关系
        this.sendData.attribute.echoMap[item.countName] = item.pointData.fullName
        // 存储点位
        this.sendData.attribute.objectServices.push(item.pointData)
      });
    },
    // 条件公式
    conditionData() {
      // 存储条件公式里的实时数据
      if (this.triggerObj.realTime) {
        this.sendData.attribute.conditionRealTimeValue.push(this.triggerObj.id)
      } else {
        this.sendData.attribute.conditionNotRealTimeValue.push(this.triggerObj.id)
      }
      // 条件公式对应关系判断
      this.sendData.attribute.conditionFormulaMap = { "a": this.triggerObj.id }
      // 条件公式里的实时数据+条件公式里的非实时数据
      this.sendData.attribute.conditionFormulaValue.push(this.triggerObj.id)
      // 条件公式里的变量和点位位置对应关系
      this.sendData.attribute.conditionEchoMap = { "a": this.triggerObj.fullName }
      // 存储点位
      this.sendData.attribute.conditionObjectServices.push(this.triggerObj)
    },
    // 清空数据
    clearSendData() {
      this.name = '';
      this.description = "";
      this.tableData = [];
      this.triggerObj = {}
      this.enableFormula = '';
      this.sendData = {
        name: "",
        parentId: "",
        id: null,
        type: 'value_calculation',
        description: "",
        fullId: null,
        unit: null,
        secondName: null,
        memo: null,
        mqttId: null,
        keyPrefix: null,
        attribute: {
          realTimeValue: [],
          notRealTimeValue: [],
          formulaMap: {},
          formulaValue: [],
          echoMap: {},
          status: true,
          objectServices: [],
          formula: "",
          condition: 'a==1', // 不填
          conditionRealTimeValue: [],// 不填
          conditionNotRealTimeValue: [],// 不填
          conditionFormulaMap: {},// 不填
          conditionFormulaValue: [],// 不填
          conditionEchoMap: {},// 不填
          conditionObjectServices: [],// 不填
        },
      }
    },
    // 组装数据
    assembleTableData() {
      const formulaMap = this.objectInfo.attribute.formulaMap
      const objectServices = this.objectInfo.attribute.objectServices

      // 1️⃣ 先把 objectServices 转成 id -> 对象 的映射
      const serviceMap = {}
      objectServices.forEach(item => {
        serviceMap[item.id] = item
      })
      // 2️⃣ 组装 tableData
      const tableDataTest = []
      Object.keys(formulaMap).forEach(varName => {
        const id = formulaMap[varName]
        const point = serviceMap[id]
        if (!point) return
        tableDataTest.push({
          countName: varName,
          name: point.name,
          address: point.fullName,
          type: "",
          pointData: point
        })
      })
      // 3️⃣ 赋值
      this.tableData = tableDataTest
    },
    getNodeData(id) {
      service.getNode(id).then(res => {
        if (res.type == "value_calculation") {
          this.objectInfo = res
        }
      })
    }

  }
}
</script>




<style scoped>
.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

fieldset {
  padding: 10px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.tit {
  color: #ffffff;
}

.txt {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/point/valueCalculation.vue